import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { ChartBarLineIcon, Clock01Icon, JusticeScale01Icon, UserMultiple02Icon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
export function ResolutionIntegrityHelpModal(t0) {
  const $ = _c(56);
  const {
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  let t1;
  if ($[0] !== t) {
    t1 = t("helpTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("helpDescription");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("helpGotIt");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[6] = onOpenChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <InfoModal.Footer cta={t3} onClose={t4} />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("helpScoreTitle");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("helpScoreDescription");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <InfoModal.IconItem icon={JusticeScale01Icon} title={t6} description={t7} />;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("helpCompareTitle");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("helpCompareDescription");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <InfoModal.IconItem icon={UserMultiple02Icon} title={t9} description={t10} />;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("helpWhenTitle");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("helpWhenDescription");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <InfoModal.IconItem icon={Clock01Icon} title={t12} description={t13} />;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("helpTableTitle");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("helpTableDescription");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <InfoModal.IconItem icon={ChartBarLineIcon} title={t15} description={t16} />;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t11 || $[40] !== t14 || $[41] !== t17 || $[42] !== t8) {
    t18 = <InfoModal.IconList>{t8}{t11}{t14}{t17}</InfoModal.IconList>;
    $[39] = t11;
    $[40] = t14;
    $[41] = t17;
    $[42] = t8;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t) {
    t19 = t("disclaimer");
    $[44] = t;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19) {
    t20 = <InfoModal.Callout>{t19}</InfoModal.Callout>;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== onOpenChange || $[49] !== open || $[50] !== t1 || $[51] !== t18 || $[52] !== t2 || $[53] !== t20 || $[54] !== t5) {
    t21 = <InfoModal open={open} onOpenChange={onOpenChange} size="md" title={t1} description={t2} footer={t5}>{t18}{t20}</InfoModal>;
    $[48] = onOpenChange;
    $[49] = open;
    $[50] = t1;
    $[51] = t18;
    $[52] = t2;
    $[53] = t20;
    $[54] = t5;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
}